export default {"src":"/_next/static/media/image_error.044ebc19.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};